import React, { useState } from "react";
import { subscribeNewsletter } from "../lib/api";
import { toast } from "sonner";

export default function NewsletterBlock() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            toast.error("Please enter a valid email.");
            return;
        }
        setLoading(true);
        try {
            const res = await subscribeNewsletter(email);
            if (res.already) toast("You're already subscribed.");
            else toast.success("Subscribed. Welcome to Tattva.");
            setEmail("");
        } catch {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            data-testid="newsletter-section"
            className="relative overflow-hidden bg-tattva-olive text-tattva-bg"
        >
            <img
                src="https://images.unsplash.com/photo-1761472602429-303198849d12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxkaXlhJTIwb2lsJTIwbGFtcCUyMGxpZ2h0fGVufDB8fHx8MTc3NzcwODQyOHww&ixlib=rb-4.1.0&q=85"
                alt=""
                className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-multiply"
            />
            <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-[1.2fr_1fr] gap-12 items-center">
                <div>
                    <p className="text-[11px] uppercase tracking-[0.3em] opacity-80 mb-5">
                        The Weekly Dispatch
                    </p>
                    <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] mb-5">
                        A quiet letter, every Sunday.
                    </h2>
                    <p className="text-sm md:text-base opacity-85 max-w-md leading-relaxed">
                        One shloka, one upcoming festival, one essay on the
                        science of a ritual. Nothing more. Unsubscribe in a
                        heartbeat.
                    </p>
                </div>
                <form
                    onSubmit={submit}
                    className="flex flex-col gap-4"
                    data-testid="newsletter-form"
                >
                    <label className="text-[11px] uppercase tracking-[0.25em] opacity-80">
                        Your email
                    </label>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@domain.com"
                        data-testid="newsletter-email-input"
                        className="bg-transparent border-b border-tattva-bg/60 focus:border-tattva-bg outline-none py-3 text-base placeholder:text-tattva-bg/50"
                    />
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="newsletter-submit-button"
                        className="self-start mt-2 bg-tattva-bg text-tattva-olive px-8 py-3 uppercase tracking-[0.22em] text-xs hover:bg-tattva-terracotta hover:text-tattva-bg transition-colors disabled:opacity-60"
                    >
                        {loading ? "Subscribing…" : "Subscribe"}
                    </button>
                </form>
            </div>
        </section>
    );
}
